import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdYearsCondition,
} from '@bindoc-projects/condition-domain-lib';

export class VirtualClinicAnalysisVirtualClinicOperatingNumberFilter {
  public static fromObject(
    obj: any = {},
  ): VirtualClinicAnalysisVirtualClinicOperatingNumberFilter {
    return new VirtualClinicAnalysisVirtualClinicOperatingNumberFilter(
      obj.years,
    );
  }

  constructor(public years: number[] | null = null) {}

  public clone(): VirtualClinicAnalysisVirtualClinicOperatingNumberFilter {
    const yearsClone = this.years ? this.years.slice() : null;

    return new VirtualClinicAnalysisVirtualClinicOperatingNumberFilter(
      yearsClone,
    );
  }

  public toCondition(): BdCondition {
    return new BdYearsCondition(this.years, []);
  }

  public toJSON(): unknown {
    return {
      years: this.years,
    };
  }
}
